
<form [formGroup]="paymentForm" class="space-y-4">
  <!-- Opción: Efectivo -->
  <label
    class="border border-gray-200 rounded-lg p-4 mb-1 flex items-center justify-between cursor-pointer"
    (click)="paymentForm.get('paymentMethod')?.setValue('cash'); onPaymentMethodChange('cash')"
  >
    <div class="flex items-center">
      <div class="text-green-500 mr-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" />
        </svg>
      </div>
      <div class="font-medium">Efectivo</div>
    </div>
    <div class="h-5 w-5 rounded-full border border-gray-300 flex items-center justify-center">
      @if (paymentForm.value.paymentMethod === 'cash') {
        <div class="h-3 w-3 bg-green-500 rounded-full"></div>
      }
    </div>
    <input type="radio" formControlName="paymentMethod" value="cash" class="sr-only" />
  </label>


  <!-- Opción: Tarjeta: visible solo si el balance NO alcanza -->
  @if (hideRadioCard()) {
  <label
    class="border border-gray-200 rounded-lg p-4 mb-1 flex items-center justify-between cursor-pointer"
    (click)="paymentForm.get('paymentMethod')?.setValue('card'); onPaymentMethodChange('card')"
  >
    <div class="flex items-center">
      <div class="text-yellow-500 mr-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 5a2 2 0 012-2h16a2 2 0 012 2v2H2V5zm0 6h20v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6z" />
        </svg>
      </div>
      <div class="font-medium">Tarjeta</div>
    </div>
    <div class="h-5 w-5 rounded-full border border-gray-300 flex items-center justify-center">
      @if (paymentForm.value.paymentMethod === 'card') {
        <div class="h-3 w-3 bg-yellow-500 rounded-full"></div>
      }
    </div>
    <input type="radio" formControlName="paymentMethod" value="card" class="sr-only" />
  </label>
  }
  @if (paymentForm.value.paymentMethod === 'card') {
    <mercado-pago-list-cards-user (cardSelected)="onCardSelected($event)"></mercado-pago-list-cards-user>
  }
</form>
@if (errorMessage) {
<div class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
  {{ errorMessage }}
</div>
}

<button
  (click)="processPayment()"
  [disabled]="disabledButton() || isProcessing()"
  class="w-full bg-yellow-400 hover:bg-yellow-500 text-center py-3 rounded-lg font-bold text-gray-800 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
>
  @if (!isProcessing()) {
  <span>Confirmar pedido</span>
  } @if (isProcessing()) {
  <span>Procesando...</span>
  }
</button>
